import { Route, Routes } from "react-router-dom";
import { ConsultaPrevia } from "pages/ConsultaPrevia/(index)";
import { ConsultaPreviaInicio } from "pages/ConsultaPrevia/Home";
import { FichaZona } from "pages/ConsultaPrevia/FichaZona";

export const ConsultaPreviaRoutes = () => {
  return (
    <Routes>
      <Route element={<ConsultaPrevia />}>
        <Route path="/" element={<ConsultaPreviaInicio />}>
          {/* A zona é endereçada pela sigla, como na legislação e no mapa. */}
          <Route path="zonas/:sigla" element={<FichaZona />} />
        </Route>
      </Route>
    </Routes>
  );
};
